import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { changeCategory } from "../features/catalog/catalogSlice";
import CrearButton from "./filters/ClearButton";

const CATEGORIES = [
  {
    title: 'Top Games',
    id: 'top',
    iconSrc: '/image/games/categories/icons-2025/top.webp'
  },
  {
    title: 'Asia',
    id: 'asia',
    iconSrc: '/image/games/categories/icons-2025/asia.webp'
  },
  {
    title: 'Fruits',
    id: 'fruits',
    iconSrc: '/image/games/categories/icons-2025/fruits.webp'
  },
  {
    title: 'Adventure',
    id: 'adventure',
    iconSrc: '/image/games/categories/icons-2025/adventure.webp'
  },
  {
    title: 'Festivity',
    id: 'festivity',
    iconSrc: '/image/games/categories/icons-2025/festivity-easter.webp'
  }
];

function CategorySelectItem({
  id,
  title,
  iconSrc,
  isSelected,
  onClick
}) {
  return (
    <div className={`category-select-item ${isSelected ? 'selected' : ''}`} onClick={() => onClick(id)}>
      <div className="category-select-item__inner">
        <picture>
          <source media="(max-width:767px)" srcSet="/image/games/categories/bg.svg"></source>
          <source media="(min-width:768px)" srcSet="/image/games/categories/bg-lg.svg"></source>
          <img className="category-select-item__bg category-select-item__bg--default" src="/image/games/categories/bg.svg" />
        </picture>
        <picture>
          <source media="(max-width:767px)" srcSet="/image/games/categories/bg-hover.svg"></source>
          <source media="(min-width:768px)" srcSet="/image/games/categories/bg-hover-lg.svg"></source>
          <img className="category-select-item__bg category-select-item__bg--hover" src="/image/games/categories/bg-hover-lg.svg" />
        </picture>
        <div className="category-select-item__icon-outer">
          <img className="category-select-item__icon" src={iconSrc} alt={title} />
        </div>
        <div className="category-select-item__title-outer">
          <span className="category-select-item__title">{title}</span>
        </div>
      </div>
    </div>
  )
}

function CategorySelect() {
  const { currentCategoryId } = useSelector((state) => state.catalog);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const onCategoryItemClick = useCallback((newId) => {
    if (currentCategoryId != newId) {
      dispatch(changeCategory(newId));
    } else {
      dispatch(changeCategory(null));
    }
  }, [currentCategoryId, dispatch]);

  return (
    <div className="category-select">
      <div className="category-select__title-outer">
        <h2 className="games-catalog__subtitle">{t('category')}</h2>
        <CrearButton />
      </div>
      <div className="category-select__list">
        {CATEGORIES.map((categoryData, index) => (
          <CategorySelectItem
            key={index}
            id={categoryData.id}
            title={t(`category-${categoryData.id}`)}
            iconSrc={categoryData.iconSrc}
            isSelected={categoryData.id === currentCategoryId}
            onClick={onCategoryItemClick}
          />
        ))}
      </div>
    </div>
  );
}

export default CategorySelect;
